import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

import { FADE_IN_OUT_ANIMATION } from '@shared/animations';

import { LoadingService } from '@shared/modules/loading';

@Component({
  moduleId: 'module.id',
  selector: 'login',
  styles: [require('./login.component.scss')],
  template: require('./login.component.html'),
  animations: [FADE_IN_OUT_ANIMATION]
})
export class LoginComponent implements OnInit {
  public username: string;
  public password: string;
  public error: Parse.Error;
  public isLoading: boolean;

  constructor(private router: Router, private loadingService: LoadingService) {
  }

  public ngOnInit(): void {

  }

  public onLogin(): void {
    this.isLoading = true;

    Parse.User.logIn(this.username, this.password).then(
      user => {
        this.router.navigate(['./admin']);
      },
      error => {
        this.error = error;
        this.isLoading = false;
    });
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+admin/modules/+login/login.component.ts